import { BlockchainEnum } from "@defuse-protocol/internal-utils"
import type { SupportedChainName } from "../types/base"

export const assetNetworkAdapter: Record<SupportedChainName, BlockchainEnum> = {
  near: BlockchainEnum.NEAR,
  eth: BlockchainEnum.ETHEREUM,
  base: BlockchainEnum.BASE,
  arbitrum: BlockchainEnum.ARBITRUM,
  bitcoin: BlockchainEnum.BITCOIN,
  bitcoincash: BlockchainEnum.BITCOINCASH,
  solana: BlockchainEnum.SOLANA,
  dogecoin: BlockchainEnum.DOGECOIN,
  turbochain: BlockchainEnum.TURBOCHAIN,
  aurora: BlockchainEnum.AURORA,
  aurora_devnet: BlockchainEnum.AURORA_DEVNET,
  xrpledger: BlockchainEnum.XRPLEDGER,
  zcash: BlockchainEnum.ZCASH,
  gnosis: BlockchainEnum.GNOSIS,
  berachain: BlockchainEnum.BERACHAIN,
  tron: BlockchainEnum.TRON,
  tuxappchain: BlockchainEnum.TUXAPPCHAIN,
  vertex: BlockchainEnum.VERTEX,
  optima: BlockchainEnum.OPTIMA,
  easychain: BlockchainEnum.EASYCHAIN,
  hako: BlockchainEnum.HAKO,
  polygon: BlockchainEnum.POLYGON,
  bsc: BlockchainEnum.BSC,
  hyperliquid: BlockchainEnum.HYPERLIQUID,
  ton: BlockchainEnum.TON,
  optimism: BlockchainEnum.OPTIMISM,
  avalanche: BlockchainEnum.AVALANCHE,
  sui: BlockchainEnum.SUI,
  stellar: BlockchainEnum.STELLAR,
  aptos: BlockchainEnum.APTOS,
  cardano: BlockchainEnum.CARDANO,
  litecoin: BlockchainEnum.LITECOIN,
  layerx: BlockchainEnum.LAYERX,
  monad: BlockchainEnum.MONAD,
  adi: BlockchainEnum.ADI,
  starknet: BlockchainEnum.STARKNET,
  plasma: BlockchainEnum.PLASMA,
  scroll: BlockchainEnum.SCROLL,
  aleo: BlockchainEnum.ALEO,
  dash: BlockchainEnum.DASH,
}

export const reverseAssetNetworkAdapter: Record<
  BlockchainEnum,
  SupportedChainName
> = {
  [BlockchainEnum.NEAR]: "near",
  [BlockchainEnum.ETHEREUM]: "eth",
  [BlockchainEnum.BASE]: "base",
  [BlockchainEnum.ARBITRUM]: "arbitrum",
  [BlockchainEnum.BITCOIN]: "bitcoin",
  [BlockchainEnum.BITCOINCASH]: "bitcoincash",
  [BlockchainEnum.SOLANA]: "solana",
  [BlockchainEnum.DOGECOIN]: "dogecoin",
  [BlockchainEnum.TURBOCHAIN]: "turbochain",
  [BlockchainEnum.AURORA]: "aurora",
  [BlockchainEnum.AURORA_DEVNET]: "aurora_devnet",
  [BlockchainEnum.XRPLEDGER]: "xrpledger",
  [BlockchainEnum.ZCASH]: "zcash",
  [BlockchainEnum.GNOSIS]: "gnosis",
  [BlockchainEnum.BERACHAIN]: "berachain",
  [BlockchainEnum.TRON]: "tron",
  [BlockchainEnum.TUXAPPCHAIN]: "tuxappchain",
  [BlockchainEnum.VERTEX]: "vertex",
  [BlockchainEnum.OPTIMA]: "optima",
  [BlockchainEnum.EASYCHAIN]: "easychain",
  [BlockchainEnum.HAKO]: "hako",
  [BlockchainEnum.POLYGON]: "polygon",
  [BlockchainEnum.BSC]: "bsc",
  [BlockchainEnum.HYPERLIQUID]: "hyperliquid",
  [BlockchainEnum.TON]: "ton",
  [BlockchainEnum.OPTIMISM]: "optimism",
  [BlockchainEnum.AVALANCHE]: "avalanche",
  [BlockchainEnum.SUI]: "sui",
  [BlockchainEnum.STELLAR]: "stellar",
  [BlockchainEnum.APTOS]: "aptos",
  [BlockchainEnum.CARDANO]: "cardano",
  [BlockchainEnum.LITECOIN]: "litecoin",
  [BlockchainEnum.LAYERX]: "layerx",
  [BlockchainEnum.MONAD]: "monad",
  [BlockchainEnum.ADI]: "adi",
  [BlockchainEnum.STARKNET]: "starknet",
  [BlockchainEnum.PLASMA]: "plasma",
  [BlockchainEnum.SCROLL]: "scroll",
  [BlockchainEnum.ALEO]: "aleo",
  [BlockchainEnum.DASH]: "dash",
}

export function isValidBlockchainEnumKey(
  key: string
): key is keyof typeof reverseAssetNetworkAdapter {
  return key in reverseAssetNetworkAdapter
}
